import { apiNet } from '@cems-eco/core/src/services/api';

export abstract class BaseLogApi {
    private BASE_URL: string;

    
    constructor() {
        this.BASE_URL = "/log";
    }

    async all(): Promise<any> {
        return await apiNet.get<any>(this.BASE_URL);
    }

    async first(id: any): Promise<any> {
        return await apiNet.get<any>(`${this.BASE_URL}/${id}`);
    }

    async create(data: any): Promise<any> {
        return await apiNet.post<any>(this.BASE_URL, data);
    }

    async edit(id: any, data: any): Promise<any> {
        return await apiNet.put<any>(`${this.BASE_URL}/${id}`, data);
    }

    async destroy(id: any): Promise<any> {
        return await apiNet.delete<any>(`${this.BASE_URL}/${id}`);
    }

}
